<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                regionTypeForm: () => import('../forms/RegionTypeForm'),
                fields: [
                    { type: 'text', text: 'Name', value: 'name', rules: [v => !!v || 'Name is required', v => !(v && v.length > 450) || 'Name must be less than 450 characters'], isRequired: true, maxLength: 450 },
                    { type: 'autocomplete', text: 'Region Type', value: 'regionTypeId', rules: [v => !!v || 'Region Type is required'], isRequired: true, form: () => import('./RegionTypeForm'), apiMethod: 'RegionTypes', claim: 'RegionTypes' },
                ],
                apiMethod: 'Regions',
                formTitle: 'Region',
            }
        },
    };
</script>
